import React, { createContext, useContext, useEffect, useState } from "react";

// 1. Create Context
export const A2HSContext = createContext(null);

// 2. Create custom hook
export const useA2HSContext = () => {
    const context = useContext(A2HSContext);

    if (!context) {
        throw new Error('useA2HSContext must be used within an A2HSProvider');
    }
    return context;
};

// 3. Create Provider
export const A2HSProvider = ({ children }) => {
    const [prompt, setState] = useState(null);

    const promptToInstall = () => {
        if (prompt) {
            return prompt.prompt();
        }
        return Promise.reject(new Error('Tried installing before browser sent "beforeinstallprompt" event'));
    };

    useEffect(() => {
        const ready = (e) => {
            e.preventDefault();
            setState(e);
        };

        window.addEventListener('beforeinstallprompt', ready, false);

        return () => {
            window.removeEventListener('beforeinstallprompt', ready, false);
        };
    }, []);

    return <A2HSContext.Provider value={{ prompt, promptToInstall }}>{children}</A2HSContext.Provider>;
};